/**
 * DAISE voice filter — shared by the edge Worker (belt: filters model output
 * before it leaves the server, issue #37) and the game client (braces: mirrors
 * the same rejection before presenting, issue #38). One module so the two
 * sides can never drift.
 *
 * A line survives only if it could have come from the bank: no exclamation
 * points ever, no self-naming in any form, no markdown furniture, bank-like
 * length. Rejection returns null — callers fall back to the bank.
 */

/** strip markdown furniture the models love, without touching prose */
function stripMarkdown(s: string): string {
  return s
    .replace(/^[#>\-*\d.)\s]+/, '')
    .replace(/[*_`]+/g, '')
    .replace(/^["'“‘]+|["'”’]+$/g, '')
    .trim()
}

/** a feed line survives only if it could have come from the bank */
export function filterLine(raw: string): string | null {
  const s = stripMarkdown(raw)
  if (!s || s.includes('!')) return null
  if (/daise|daisy/i.test(s)) return null
  const words = s.split(/\s+/).length
  // DECISION: hard floor of 4 words (the prompt asks for 8–30) — the bank
  // itself has terse 5-word lines, so 4 rejects only fragments, not voice
  if (words < 4 || words > 30) return null
  return s
}

/** the incident report: 2–6 sentences of connected prose, same absolute constraints */
export function filterReport(raw: string): string | null {
  const s = stripMarkdown(raw).replace(/\s*\n+\s*/g, ' ')
  if (!s || s.includes('!')) return null
  if (/daise|daisy/i.test(s)) return null
  const words = s.split(/\s+/).length
  if (words < 12 || words > 140) return null
  const sentences = s.split(/[.?]+\s/).filter((x) => x.trim().length > 0).length
  if (sentences < 2 || sentences > 7) return null
  return s
}
